import { TypePolicy } from '@apollo/client'

export const professionalDisciplinePolicy = {
    professionalDiscipline: {
        keyFields: ['firstName', 'lastName'], // or use another unique combination for professionalDiscipline
    } as TypePolicy,
}
